import React, { useEffect } from 'react'
import { useState } from 'react'
import { BiCheck } from 'react-icons/bi'
import { BsArrowRightShort } from 'react-icons/bs'
import { FaRegTimesCircle } from 'react-icons/fa'

import './style.css'

const Services = () => {
  const [fixed, setfixed] = useState('services-card');
  const [fixed2, setfixed2] = useState('services-card');
  const [fixed3, setfixed3] = useState('services-card');
  const handleShowService = (e) => { setfixed('services-cards-fixed') }
  const handleShowService2 = (e) => { setfixed2('services-cards-fixed') }
  const handleShowService3 = (e) => { setfixed3('services-cards-fixed') }

  const removeFixed = () => { setfixed('none-div') }
  const removeFixed2 = () => { setfixed2('none-div') }
  const removeFixed3 = () => { setfixed3('none-div') }

  // {fixed === 'services-card' ? 'services-card' :'none-div'}


  useEffect(() => {

    console.log('1')

  }, [fixed]);

  return (
    <section id='service'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className='container services_container'>
        {/* Start Content Creative */}
        <div className="services-cards">
          <div className='services-card'>
            <h3>Website Manager</h3>
            <span onClick={handleShowService}>See more <BsArrowRightShort className='services-icon' /></span>
            <div className={fixed === 'services-card' ? 'none-div' : fixed} >
              <div className="fixed-bulr"></div>
              <FaRegTimesCircle className='esc' onClick={removeFixed} />
              <div className='header-service-menu'>
                <h2>Website Manager</h2>
                <p>Over 2 years of experience managing and optimizing websites for performance, visibility, and conversion.</p>
              </div>
              <ul>
                <li><BiCheck />Built and customized websites using Wix and Shopify</li>
                <li><BiCheck />Optimized site SEO for better search engine ranking</li>
                <li><BiCheck />Managed website deployment and updates on Netlify</li>
                <li><BiCheck />Implemented responsive design and UX best practices</li>
                <li><BiCheck />Monitored analytics and traffic to improve performance</li>
              </ul>
            </div>
          </div>
          {/* End Card a */}
          <div className='services-card'>
            <h3>Full-Stack Developer</h3>
            <span onClick={handleShowService2}>See more <BsArrowRightShort className='services-icon' /></span>
            <div className={fixed2 === 'services-card' ? 'none-div' : fixed2} >
              <div className="fixed-bulr"></div>
              <FaRegTimesCircle className='esc' onClick={removeFixed2} />
              <div className='header-service-menu'>
                <h2>Full-stack Developer</h2>
                <p>2+ years of experience building responsive, scalable web applications from concept to deployment using modern full-stack technologies.</p>
              </div>
              <ul>
                <li><BiCheck />Developed dynamic UIs with React and Tailwind CSS</li>
                <li><BiCheck />Built and maintained RESTful APIs with Node.js and Express</li>
                <li><BiCheck />Integrated MongoDB for robust, flexible data storage</li>
                <li><BiCheck />Managed version control and collaboration using Git and GitHub</li>
                <li><BiCheck />Deployed full-stack applications using Netlify and Render</li>
              </ul>
            </div>
          </div>
          {/* End Card a */}
          <div className='services-card'>
            <h3>Data Analyst</h3>
            <span onClick={handleShowService3}>See more <BsArrowRightShort className='services-icon' /></span>
            <div className={fixed3 === 'services-card' ? 'none-div' : fixed3} >
              <div className="fixed-bulr"></div>
              <FaRegTimesCircle className='esc' onClick={removeFixed3} />
              <div className='header-service-menu'>
                <h2>Data Analyst</h2>
                <p>Service with 2+ years of academic and project-based experience. Delivering data-driven insights and building scalabale solutions for decision-making.</p>
              </div>
              <ul>
                <li><BiCheck />Performed data analysis using Python, Pandas, and NumPy</li>
                <li><BiCheck />Designed and optimized MySQL databases for structured data storage</li>
                <li><BiCheck />Created dashboards and visual reports using Matplotlib and Seaborn</li>
                <li><BiCheck />Collaborated using Git & GitHub for version control and team contribution</li>
              </ul>
            </div>
          </div>
          {/* End Card a */}



        </div>
      </div>
    </section>
  )
}

export default Services